<template>
  <q-list>
    <div v-for="(item, index) in router" :key="index">
      <q-expansion-item
        v-if="item.children.length<1"
        :header-inset-level="initLevel"
        expand-icon="1"
        :to="item.path"
        :icon="item.icon"
        :label="item.label"
      />
      <q-expansion-item
        v-else
        expand-separator
        :header-inset-level="initLevel"
        :to="item.path"
        :icon="item.icon"
        :label="item.label"
      >
        <my-menu :router="item.children" :initLevel="initLevel+0.3"/>
      </q-expansion-item>
    </div>
  </q-list>
</template>

<script>
export default {
    name:'myMenu',
    props:{
        router:Array,
        initLevel:Number
    }
};
</script>

<style>
</style>